import {
    useState,
    useEffect,
    useRef,
    forwardRef,
    useImperativeHandle,
} from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
    faSearch,
    faXmark,
} from "@fortawesome/free-solid-svg-icons";
import { Loader } from "../../components/common/Loader";
import "../../styles/Common/MultiSelectDropdown.scss";
import { useDebounce } from "../../components/common/useDebounce";
import { Arrow } from "../../assets/Icons/ArrowIcons";
import { ArrowUp } from "../../assets/Icons/ArrowUp";
const MultiSelectDropDown = forwardRef((props, ref) => {
    const {
        width,
        listWidth = width,
        name,
        label,
        isCompulsory,
        options,
        optionLimit = false,
        preSelectedValues = [],
        searchPlaceholder,
        disabled,
        remoteData = false,
        selectAllOption = false,
        direction = "down",
        defaultAllSelected = false,
        id,
        nextId,
        prevId,
        autoFocus = false,
        showCrossIcon = false,
        searchByCode = false,
        searchByName = "",
        showSearch = true,
    } = props;
    const defaultValue = Object.assign([], preSelectedValues);
    const [preSelectedState, setPreSelectedState] = useState([]);
    const [showDrop, setShowDrop] = useState(false);
    const [focus, setFocus] = useState(false);
    const [blur, setBlur] = useState(true);
    const [list, setList] = useState(options);
    const [selectedDisplayValue, setSelectedDisplayValue] = useState("");
    const [selectedValues, setSelectedValues] = useState([]);
    const [searchInput, setSearchInput] = useState("");
    const [remoteSearchInput, setRemoteSearchInput] = useState("");
    const [filteredLists, setFilteredLists] = useState(options);
    const [loading, setLoading] = useState(false);
    const dropRef = useRef(null);
    const searchInputRef = useRef(null);
    const debouncedSearchTerm = useDebounce(remoteSearchInput, 500);
    const debouncedSearchTerm2 = useDebounce(searchInput, 500);
    const [currentPage, setCurrentPage] = useState(1);
    const [allSelected, setAllSelected] = useState(defaultAllSelected);
    const [cursor, setCursor] = useState(-1);
    //const suggestions = searchInput !== "" ? filteredLists : list;
    const input1ref = useRef(null);
    const searchResultRef = useRef(null);
    useEffect(() => {
        if (autoFocus) {
            input1ref.current.focus();
        }
    }, []);
    useEffect(() => {
        if (cursor < 0 || cursor > filteredLists.length || !searchResultRef) {
            return () => { };
        }
        if (
            searchResultRef &&
            searchResultRef.current &&
            searchResultRef.current.children
        ) {
            let listItems = Array.from(searchResultRef.current.children);
            listItems[cursor] && scrollIntoView(listItems[cursor].offsetTop - 30);
        }
    }, [cursor]);
    const scrollIntoView = (position) => {
        searchResultRef.current.parentNode.scrollTo({
            top: position,
            behavior: "smooth",
        });
    };
    useEffect(() => {
        setAllSelected(defaultAllSelected);
    }, [defaultAllSelected, options]);
    useEffect(() => {
        if (preSelectedValues.length === 0) {
            setSelectedDisplayValue("");
            setAllSelected(false);
        }
        if (
            preSelectedState.length !== preSelectedValues.length &&
            preSelectedValues.length === 1
        ) {
            setAllSelected(false);
        }
        if (
            preSelectedState.length !== preSelectedValues.length &&
            preSelectedValues.length > 1
        ) {
            setAllSelected(true);
        }
        if (preSelectedValues.length === 1) {
            setAllSelected(false);
        }
        setPreSelectedState(preSelectedValues);
    }, [preSelectedValues]);

    useEffect(() => {
        document.addEventListener("mousedown", handleClickOutside);
        return () => document.removeEventListener("mousedown", handleClickOutside);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [dropRef]);

    useEffect(() => {
        const { options } = props;
        setList(options);
        if (optionLimit) {
            setFilteredLists(options.slice(0, optionLimit));
        } else {
            setFilteredLists(options);
        }

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [options]);
    useEffect(() => {
        if (optionLimit) {
            const startIndex = (currentPage - 1) * optionLimit;
            const endIndex = startIndex + optionLimit;
            setFilteredLists(options.slice(startIndex, endIndex));
        }
    }, [options]);

    const debounce = (func, delay) => {
        let timeoutId;
        return function (...args) {
            const context = this;
            clearTimeout(timeoutId);
            timeoutId = setTimeout(() => func.apply(context, args), delay);
        };
    };

    function throttle(func, wait) {
        let lastTime = 0;
        return function (...args) {
            const now = new Date().getTime();
            if (now - lastTime >= wait) {
                lastTime = now;
                func.apply(this, args);
            }
        };
    }
    const srcollToEnd = (target, onBottom, onTop) => {
        const { scrollTop, scrollHeight, clientHeight } = target;
        if (onBottom) {
            const newValue = currentPage + 1;
            const startIndex = (newValue - 1) * optionLimit;
            const endIndex = startIndex + optionLimit;
            const newArr = options.slice(startIndex, endIndex);

            if (newArr.length > 0) {
                setFilteredLists(newArr);
                setCurrentPage(newValue);
                target.scrollTo({
                    top: 3,
                    behavior: 'smooth' // Optionally, use smooth scrolling
                });
            }
        } else if (onTop) {
            const newValue = currentPage - 1;
            const startIndex = (newValue - 1) * optionLimit;
            const endIndex = startIndex + optionLimit;
            const newArr = options.slice(startIndex, endIndex);

            if (newArr.length > 0) {
                setFilteredLists(newArr);
                setCurrentPage(newValue);
                target.scrollTo({
                    top: scrollHeight - scrollTop - clientHeight - 20,
                    behavior: 'smooth' // Optionally, use smooth scrolling
                });
            }
        }

    }
    const handleTrottle = throttle(srcollToEnd, 2000)
    const handleScroll = debounce((e) => {
        if (!optionLimit) return;
        const { target } = e;
        const { scrollTop, scrollHeight, clientHeight } = target;
        const bottomOffset = scrollHeight - scrollTop - clientHeight;
        const topOffset = scrollTop;
        const onBottom = bottomOffset < 2
        const onTop = topOffset < 2 && currentPage > 1
        if (onBottom || onTop) {
            handleTrottle(target, onBottom, onTop)
        }
    }, 100); // Consider setting a debounce time to limit rapid calls

    useEffect(() => {
        if (defaultValue.length > 0 && options.length > 0) {
            const { isObject, primaryKey } = props;
            if (isObject) {
                let selectedItems = [];
                for (let dv of defaultValue) {
                    const selectedItem = list.find(
                        (l) => l[primaryKey] === dv[primaryKey]
                    );
                    if (selectedItem) {
                        selectedItems.push(selectedItem);
                    }
                }
                setSelectedValues(selectedItems);
            } else {
                setSelectedValues(defaultValue);
            }
        } else if (options.length > 0) setSelectedValues(defaultValue);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [options, preSelectedState]);

    useEffect(() => {
        const { isObject, labelKey } = props;
        if (selectedValues.length > 0) {
            if (isObject) {
                const selectedDisplayValuesArr = selectedValues.map(
                    (item) => item[labelKey]
                );
                setSelectedDisplayValue(selectedDisplayValuesArr.join(", "));
            } else {
                setSelectedDisplayValue(selectedValues.join(", "));
            }
        } else {
            setSelectedDisplayValue("");
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [selectedValues]);

    useEffect(
        () => {
            const { remoteData = false } = props;
            if (remoteData) {
                if (debouncedSearchTerm) {
                    setLoading(true);
                    fetchRemoteData(debouncedSearchTerm).then((options) => {
                        setLoading(false);
                        if (optionLimit) {
                            setFilteredLists(options.slice(0, optionLimit));
                        } else {
                            setFilteredLists(options);
                        }
                    });
                } else {
                    setFilteredLists([]);
                    setLoading(false);
                }
            }
            // eslint-disable-next-line react-hooks/exhaustive-deps
        },
        [debouncedSearchTerm] // Only call effect if debounced search term changes
    );
    useEffect(() => {
        searchItems(debouncedSearchTerm2);
    }, [debouncedSearchTerm2]);
    const fetchRemoteData = async (searchValue) => {
        const {
            fetchRemoteDataHandler = () => {
                return [];
            },
        } = props;
        let newOptions = await fetchRemoteDataHandler(searchValue);
        return newOptions;
    };

    const handleClickOutside = (e) => {
        if (!(dropRef && dropRef.current && dropRef.current.contains(e.target))) {
            setShowDrop(false);
            setCurrentPage(1)
        }
    };

    const handleDrop = (e) => {
        setSearchInput("");
        setShowDrop(true);
        setFilteredLists(list);
    };

    const onRemoveSelectedItem = (item) => {
        let index = -1;
        const { onRemove, primaryKey, isObject } = props;
        if (isObject) {
            index = selectedValues.findIndex(
                (sv) => sv[primaryKey] === item[primaryKey]
            );
        } else {
            index = selectedValues.indexOf(item);
        }
        if (index >= 0) {
            selectedValues.splice(index, 1);
            if (onRemove) onRemove(selectedValues, item);

            setSelectedValues(Object.assign([], selectedValues));
        }
    };

    const onSelectItem = (e, item) => {
        const { onSelect = () => { }, singleSelect } = props;
        e.stopPropagation();
        if (singleSelect) {
            onSingleSelect(item);
            onSelect([item], item);
            setAllSelected(false);
            setFilteredLists(options);
            return;
        }
        if (isSelectedValue(item)) {
            onRemoveSelectedItem(item);
            return;
        }
        selectedValues.push(item);
        onSelect(selectedValues, item);
        setSelectedValues(Object.assign([], selectedValues));
    };

    const onSingleSelect = (item) => {
        const { isObject, labelKey } = props;
        setSelectedValues([item]);
        setSelectedDisplayValue(isObject ? item[labelKey] : item);
        setShowDrop(false);
        setCurrentPage(1)
    };

    const updateAll = async () => {
        const { onSelect = () => { } } = props;

        const updatedSelectedValues = [...options];

        setSelectedValues(updatedSelectedValues);

        onSelect(updatedSelectedValues);

        onSelect(updatedSelectedValues);
    };
    const onSelectAll = () => {
        setAllSelected(allSelected);
        setShowDrop(false);
        setCurrentPage(1)
        updateAll()
    };
    const searchItems = (searchValue) => {
        if (remoteData) {
            setRemoteSearchInput(searchValue);
            return;
        }
        setSearchInput(searchValue);

        if (searchValue !== "") {
            let filterData = [];

            if (searchByName) {
                filterData = list.filter((item) => {
                    return item[props.searchByName].toLowerCase() === searchValue.toLowerCase();
                });
            }
            if (filterData.length === 0) {
                if (searchByCode) {
                    filterData = list.filter((item) => {
                        return item[props.labelKey]
                            .toLowerCase()
                            .includes(searchValue.toLowerCase());
                    });
                } else {
                    filterData = list.filter((item) => {
                        return item[props.labelKey]
                            .toLowerCase()
                            .includes(searchValue.toLowerCase());
                    });
                }
            }

            if (optionLimit) {
                setFilteredLists(filterData.slice(0, optionLimit));
            } else {
                setFilteredLists(filterData);
            }
            setCursor(0);
        } else {
            setFilteredLists(Object.assign([], list));
        }
    };

    const clearSearchInput = () => {
        if (searchInputRef.current) {
            searchInputRef.current.value = "";
            searchItems("");
        }
    };

    const resetItem = () => {
        const { onRemove } = props;
        setSelectedDisplayValue("");
        setSelectedValues([]);
        if (onRemove) onRemove([]);
        setAllSelected(false);
    };

    const isSelectedValue = (item) => {
        const { isObject, primaryKey } = props;
        if (isObject) {
            return (
                selectedValues.filter((i) => i[primaryKey] === item[primaryKey])
                    .length > 0
            );
        }
        return selectedValues.filter((i) => i === item).length > 0;
    };

    useImperativeHandle(ref, () => ({
        resetAutocomplete(event) {
            resetItem();
        },
    }));

    const renderOptionList = () => {
        const {
            loadingMessage = "Loading...",
            isObject,
            style = [],
            labelKey,
            primaryKey,
            noDataLabel = "No results found",
        } = props;
        if (loading) {
            return (
                <div className="loading-container">
                    <Loader />
                    {typeof loadingMessage === "string" && (
                        <span style={style["loadingMessage"]} className={`not--found`}>
                            {loadingMessage}
                        </span>
                    )}
                </div>
            );
        }
        return filteredLists.length > 0 ? (
            <>
                {selectAllOption && (
                    <li>
                        <div
                            key={"selAll"}
                            className={`drop--item ${allSelected ? "selected" : ""} ${cursor === -1 ? "highlighted" : ""
                                }`}
                            onClick={onSelectAll}
                        >
                            <div>Select All</div>
                        </div>
                    </li>
                )}

                {(optionLimit
                    ? filteredLists.slice(0, optionLimit)
                    : filteredLists
                ).map((el, index) => {
                    const isSelected = isSelectedValue(el);
                    const optionKey = isObject ? el[primaryKey] : `${el}-${index}`;
                    const optionLabel = isObject ? el[labelKey] : el;
                    return (
                        <li>
                            <div
                                key={optionKey}
                                className={`drop--item ${isSelected ? "selected" : ""} ${cursor === index ? "highlighted" : ""
                                    }`}
                                onClick={(e) => onSelectItem(e, el)}
                            >
                                <div>{optionLabel}</div>
                            </div>
                        </li>
                    );
                })}
            </>
        ) : (
            <div className="not--found">{noDataLabel}</div>
        );
    };

    const labelTxyt = isCompulsory ? (
        <span>
            {label}
            <span style={{ color: "red", paddingLeft: "5px" }}>*</span>
        </span>
    ) : (
        label
    );
    const showSuggestion = (e, el) => {
        e.stopPropagation();
        setShowDrop(true);
    };
    const hideSuggestion = (e, el) => {
        setShowDrop(false);
        setCurrentPage(1)

    };
    const focusElemnt = (elementID) => {
        elementID &&
            document.getElementById(elementID) &&
            document.getElementById(elementID).focus();
    };
    const focusNextElement = (e) => {
        focusElemnt(nextId);
        e.preventDefault();
    };
    const focusPrevElement = () => {
        focusElemnt(prevId);
    };

    const keyboardNavigation1 = (e) => {
        if (e.key === "ArrowDown" && !disabled) {
            showSuggestion(e);
        }
        if (e.key === "ArrowUp" && !disabled) {
            showSuggestion(e);
        }
        if (e.key === "Escape") {
            focusPrevElement();
        }
        if (e.key === "Enter" || e.key === "Tab") {
            focusNextElement(e);
        }
    };
    const keyboardNavigation2 = (e) => {
        if (e.key === "ArrowDown") {
            showDrop
                ? setCursor((c) => (c < filteredLists.length - 1 ? c + 1 : -1))
                : showSuggestion();
        }

        if (e.key === "ArrowUp") {
            setCursor((c) => (c > 0 ? c - 1 : -1));
        }

        if (e.key === "Escape") {
            hideSuggestion();
            input1ref.current.focus();
        }

        if ((e.key === "Enter" || e.key === "Tab") && cursor > -1) {
            const { onSelect = () => { }, singleSelect } = props;
            e.stopPropagation();
            const item = filteredLists[cursor];
            if (singleSelect) {
                onSingleSelect(item);
                onSelect([item], item);
                setAllSelected(false);
                setFilteredLists(options);
                focusNextElement(e)
                return;
            }
            if (isSelectedValue(item)) {
                onRemoveSelectedItem(item);
                return;
            }
            selectedValues.push(item);
            onSelect(selectedValues, item);
            setSelectedValues(Object.assign([], selectedValues));
            hideSuggestion();
            nextId ? focusNextElement(e) : input1ref.current.focus();
        }
    };
    return (
        <div
            className={`multidropdown--wrapper ${disabled ? "disable" : ""}`}
            style={{ width: width }}
            ref={dropRef}
            onClick={handleDrop}
        >
            <input
                type="text"
                className={`inp--field ${disabled ? "disable" : ""} ${showDrop ? "focusColor" : ""
                    }`}
                value={allSelected ? `All ${label}` : selectedDisplayValue}
                readOnly
                id={id}
                ref={input1ref}
                onKeyDown={keyboardNavigation1}
                onClick={showSuggestion}
            />
            {showCrossIcon && (selectedDisplayValue && !disabled) ? (
                <div className="cross--icon" onClick={resetItem}>
                    <span className="cross" style={{ display: showCrossIcon ? 'block' : 'none' }}>
                        <FontAwesomeIcon icon={faXmark} color={"#666666"} />
                    </span>
                </div>
            ) : null}
            <div className="caret--icon">{showDrop ? <ArrowUp /> : <Arrow />}</div>
            <div
                className={`inp--label ${showDrop ? "focus--label" : ""} ${focus ? "active" : selectedDisplayValue && blur ? " filled" : ""
                    }`}
            >
                {labelTxyt}
            </div>
            {showDrop && (
                <div
                    className={`drop--wrapper ${direction === "up" ? "up" : "down"}`}
                    style={{ width: listWidth }}
                >
                    {showSearch &&
                        <div className="drop--search">
                            <input
                                name={name}
                                type="text"
                                className="search"
                                placeholder={searchPlaceholder}
                                onChange={(e) => searchItems(e.target.value)}
                                onKeyDown={(e) => keyboardNavigation2(e)}
                                ref={searchInputRef}
                                autoFocus
                                autoComplete={"off"}
                            />
                            <div className="search--icon">
                                <FontAwesomeIcon icon={faSearch} color={"#777"} />
                            </div>
                            {(searchInput || remoteSearchInput) && (
                                <div className="cross--icon" onClick={clearSearchInput}>
                                    <span className="cross">
                                        <FontAwesomeIcon icon={faXmark} color={"#777"} />
                                    </span>
                                </div>
                            )}
                        </div>
                    }
                    <div className="drop--content scroll" onScroll={handleScroll}>
                        <ul className="list-group" ref={searchResultRef}>
                            {renderOptionList()}
                        </ul>
                    </div>
                </div>
            )}
        </div>
    );
});

export default MultiSelectDropDown;
